import { render, staticRenderFns } from "./SuggestSwapModal.vue?vue&type=template&id=1f4d11e5&scoped=true"
import script from "./SuggestSwapModal.vue?vue&type=script&lang=js"
export * from "./SuggestSwapModal.vue?vue&type=script&lang=js"
import style0 from "./SuggestSwapModal.vue?vue&type=style&index=0&id=1f4d11e5&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f4d11e5",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/SysClass-Web-App/SysClass-Web-App/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1f4d11e5')) {
      api.createRecord('1f4d11e5', component.options)
    } else {
      api.reload('1f4d11e5', component.options)
    }
    module.hot.accept("./SuggestSwapModal.vue?vue&type=template&id=1f4d11e5&scoped=true", function () {
      api.rerender('1f4d11e5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/sys/ambience/SuggestSwapModal.vue"
export default component.exports